














































































































































































































































































import { LANG } from "@/common/constant";
import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import {
  formatImageUrl,
  getAttributeByLangCamelCase,
  getAttributeByLangSnakeCase,
} from "@/common/utils";
import { Component, Vue } from "vue-property-decorator";
// eslint-disable-next-line @typescript-eslint/no-var-requires
const noImage = require("@/assets/images/muuq-base/noimage.svg");

@Component({
  name: "LivePreviewComponent",
  components: {
    QSearch,
    QPaginate,
    QTableHeader,
  },
})
export default class LivePreviewComponent extends Vue {
  public show: any = {};

  public isShow = false;
  public showItem: any = {};
  public async mounted() {
    const show = localStorage.getItem("show");
    this.show = JSON.parse(show);
  }

  public getTotal() {
    if (this.show.items) {
      return this.show.items.length;
    }
    return 0;
  }

  public getEnd() {
    if (this.show.items) {
      return this.show.items.length;
    }
    return 0;
  }

  public formatImageUrl(fileName, size = "1600x800", type = "contain", color) {
    return fileName ? formatImageUrl(fileName, size, type, color) : noImage;
  }

  public getContentByLangCamelCase(object, attributeName) {
    if (this.$route.query.lang) {
      return getAttributeByLangCamelCase(
        object,
        attributeName,
        this.$route.query.lang,
      );
    }

    return getAttributeByLangCamelCase(object, attributeName, LANG.JA);
  }

  public getContentByLangSnakeCase(object, attributeName) {
    if (this.$route.query.lang) {
      return getAttributeByLangSnakeCase(
        object,
        attributeName,
        this.$route.query.lang,
      );
    }

    return getAttributeByLangSnakeCase(object, attributeName, LANG.JA);
  }

  public translateAttribute(attributeName) {
    const currentLang = this.$route.query.lang ? this.$route.query.lang : LANG.JA;
    return this.$t(attributeName, `${currentLang}`);
  }

  public showDetail(title, item, show) {
    const lang = this.$route.query.lang ? this.$route.query.lang : LANG.JA;
    this.isShow = true;
    const count = show[lang === "ja" ? "count" : "count_" + lang];
    const awardGroup =
      item[lang === "ja" ? "award_group" : "award_group_" + lang];
    const kind = item[lang === "ja" ? "kind" : "kind_" + lang];
    const award = item[lang === "ja" ? "award" : "award_" + lang];
    const itemTitle = `${count ?? ""} ${title ?? ""} ${awardGroup ?? ""} ${
      kind ?? ""
    } ${award ?? ""}`;
    this.showItem = item;
    this.showItem.item_title = itemTitle;
  }
}
